import React from 'react';
import { useTranslation } from 'react-i18next';

export default function About() {
    const { t } = useTranslation(['metadata']);
    return (
        <>
            <div className="p-8 bg-white rounded-md">
                <div className="flex justify-between">
                    <div className="font-semibold text-xl">{t("About")}</div>
                </div>
                <div
                    className="my-3"
                    style={{ borderBottom: '1px solid #DEDEE3' }}
                ></div>
                <div class="grid grid-cols-2 gap-2 text-sm">
                    <div className="grid grid-cols-10 pb-1">
                        <div className="col-span-3 font-semibold">{t("Create Date")} :</div>
                        <div className="col-span-7">-</div>
                    </div>
                    <div className="grid grid-cols-10 pb-1">
                        <div className="col-span-3 font-semibold">{t("Update Date")} :</div>
                        <div className="col-span-7">-</div>
                    </div>
                    <div className="grid grid-cols-10 pb-1">
                        <div className="col-span-3 font-semibold">{t("Create By")} :</div>
                        <div className="col-span-7">-</div>
                    </div>
                    <div className="grid grid-cols-10 pb-1">
                        <div className="col-span-3 font-semibold">{t("Update By")} :</div>
                        <div className="col-span-7">-</div>
                    </div>
                </div>
            </div>
        </>
    );
}
